import { Link } from '@tanstack/react-router';

import { DisplayHeading, Eyebrow } from '@/components/editorial';
import type { PublicProjectRecord } from '@/content/schemas';

import { ProjectArchiveCard } from './project-archive-card';

type ProjectsIndexPageProps = {
  projects: PublicProjectRecord[];
};

export function ProjectsIndexPage({ projects }: ProjectsIndexPageProps) {
  return (
    <div className="container max-w-5xl px-6 py-16 md:py-24">
      <div className="mb-14">
        <Eyebrow className="mb-4">Selected work</Eyebrow>
        <DisplayHeading as="h1" size="xl" animate={false}>
          Projects
        </DisplayHeading>
        <p className="text-muted-foreground mt-4 max-w-xl text-lg leading-relaxed">
          Every published project from the canonical manifest. Case studies link
          to full write-ups; index-only records stay in the archive without a
          detail route.
        </p>
        <p className="text-muted-foreground mt-3 font-mono text-xs">
          {projects.length} {projects.length === 1 ? 'project' : 'projects'}
        </p>
      </div>

      {projects.length === 0 ? (
        <p className="text-muted-foreground py-16 text-center font-mono text-sm">
          No published projects yet.
        </p>
      ) : (
        <div className="flex flex-col gap-6">
          {projects.map((project, index) => (
            <ProjectArchiveCard
              key={project.id}
              project={project}
              index={index + 1}
            />
          ))}
        </div>
      )}

      <div className="mt-12">
        <Link
          to="/"
          className="text-muted-foreground hover:text-brand font-mono text-sm transition-colors"
        >
          ← Back to home
        </Link>
      </div>
    </div>
  );
}
